function fail(message) {
  throw new Error(message || "Assertion failed");
}

function assert(value, message) {
  if (!value) fail(message);
}

assert.ok = assert;
assert.equal = function (actual, expected, message) {
  if (actual != expected) fail(message || String(actual) + " != " + String(expected));
};
assert.strictEqual = function (actual, expected, message) {
  if (actual !== expected) fail(message || String(actual) + " !== " + String(expected));
};

module.exports = assert;
